/**
 * Dalbe Gallery page (/pages/galeria-kepek).
 * The hide-non-matching-photos and project-title work both happen
 * synchronously in an inline <script> in dalbe-gallery.liquid, before this
 * deferred module runs — otherwise the full unfiltered grid, or an empty
 * project title, would flash visible for a beat first. This file only
 * handles what doesn't need to happen before first paint: the empty-state
 * message and the lightbox. Visibility is re-derived from data-project
 * rather than read off the DOM (that inline script hides things via an
 * injected stylesheet rule, not inline styles, so element.style.display
 * would not reflect it).
 */

const params = new URLSearchParams(window.location.search);
const project = params.get('project');

const emptyState = document.getElementById('dalbe-gallery-empty-state');
const items = Array.from(document.querySelectorAll('.dalbe-gallery__item'));

if (project) {
  const visibleCount = items.filter((item) => item.dataset.project === project).length;
  if (visibleCount === 0 && emptyState) emptyState.style.display = 'block';
}

// Lightbox — built on the same <dialog> pattern as house-gallery-lightbox.js.
// Triggers are scoped to the current project when filtered, so a filtered
// view's prev/next navigation only ever cycles through that project's photos.
const lightbox = document.querySelector('[data-gallery-lightbox]');

if (lightbox) {
  const image = lightbox.querySelector('[data-gallery-image]');
  const counter = lightbox.querySelector('[data-gallery-counter]');
  const triggers = project ? items.filter((item) => item.dataset.project === project) : items;
  let currentIndex = 0;

  function show(index) {
    currentIndex = (index + triggers.length) % triggers.length;
    const trigger = triggers[currentIndex];
    image.src = trigger.dataset.fullSrc;
    image.alt = trigger.dataset.alt || '';
    counter.textContent = `${currentIndex + 1} / ${triggers.length}`;
  }

  triggers.forEach((trigger, index) => {
    trigger.addEventListener('click', () => {
      show(index);
      lightbox.showModal();
    });
  });

  lightbox.querySelector('[data-gallery-close]').addEventListener('click', () => lightbox.close());
  lightbox.querySelector('[data-gallery-prev]').addEventListener('click', () => show(currentIndex - 1));
  lightbox.querySelector('[data-gallery-next]').addEventListener('click', () => show(currentIndex + 1));

  const SWIPE_THRESHOLD = 50;
  let pointerStart = null;

  image.addEventListener('pointerdown', (event) => {
    pointerStart = { x: event.clientX, y: event.clientY };
  });

  image.addEventListener('pointerup', (event) => {
    if (!pointerStart) return;
    const deltaX = event.clientX - pointerStart.x;
    const deltaY = event.clientY - pointerStart.y;
    pointerStart = null;
    if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;
    show(deltaX < 0 ? currentIndex + 1 : currentIndex - 1);
  });

  image.addEventListener('pointercancel', () => {
    pointerStart = null;
  });

  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) lightbox.close();
  });

  lightbox.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowRight') show(currentIndex + 1);
    if (event.key === 'ArrowLeft') show(currentIndex - 1);
  });
}
